export default class SelectUtils {
  public static filterOption(input: string, option: any): boolean {
    const inputValue = input.toLowerCase();
    const optionValue = option.children.toLowerCase();
    return option !== undefined && optionValue.indexOf(inputValue) >= 0;
  }
}
